import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import items from './big-winners/items';

const bigWinners = combineReducers({
  items,
  isLoading: loadingStatusAccordingToReducer('bigWinnersStatusLoadingStatus'),
});

export default bigWinners;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/big-winners.reducer.js